import { Controller } from '@hotwired/stimulus'

// This controller helps in case there are nested clickable elements, eg a tooltip inside a link,
// like on the v2 project index. When clicking on the tooltip, it does not click on the clickable parent

export default class SafeClickHandlerController extends Controller {
  handleClick(event) {
    const focusableSelectors = [
      'a',
      'button',
      'input',
      'select',
      'textarea',
      '[tabindex]:not([tabindex="-1"])',
      '[role="button"]',
      '[data-bs-toggle]'
    ];

    const clickedInsideFocusable = focusableSelectors.some(selector => {
      const el = event.target.closest(selector);
      return el && el !== this.element;
      }
    );

    if (clickedInsideFocusable) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
